import React from "react";
import styled from "styled-components";
import {Cell} from "./Cell";
import {Link} from "react-router-dom";

export const portfolioNameWidth = 180;

const Container = styled(Cell)`
    flex-basis: ${portfolioNameWidth + "px"};
    overflow: hidden;
    padding-right: 12px;
    min-width: 120px;
`;

const Header = styled(Container)`
    font-size: 11px;
    font-weight: bold;
`;

const Closed = styled(Container)`
    border-right: solid 1px #d6d0c8;
`;

const PortfolioLink = styled(Link)`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-decoration: none;
    color: #4a4a4a;
    cursor: hand;
    
    :hover {
      color: #3b7433;
    }
    
    :active {
      color: #4a4a4a;
    }
`;

const Name = styled.div`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;

const PortfolioName = ({portfolioIdea: {id, name, authorConnected}, authorId, currentUserId}) => {
    if (authorConnected && authorId === currentUserId) {
        return <PortfolioLink to={`/contribute/${id}/${currentUserId}`} target="_blank">{name}</PortfolioLink>;
    } else {
        return <Name>{name}</Name>;
    }
};

export const PortfolioNameCell = ({portfolioIdea, authorId, currentUserId}) => {
  return <Container className="t-portfolio-name">
      <PortfolioName portfolioIdea={portfolioIdea} authorId={authorId} currentUserId={currentUserId}/>
  </Container>
};


export const ClosedPortfolioNameCell = ({portfolioIdea, authorId, currentUserId}) => {
  return <Closed className="t-portfolio-name">
      <PortfolioName portfolioIdea={portfolioIdea} authorId={authorId} currentUserId={currentUserId}/>
  </Closed>
};



export const PorfolioNameHeader = () => {
    return <Header>Portfolio</Header>;
};